import React from 'react';
import styled from 'styled-components';

// Styled Components
const Container = styled.div`
  max-width: 800px;
  margin: 5px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const List = styled.ul`
  color: #555;
  line-height: 1.6;
  margin-left: 20px;
  margin-bottom: 10px;
`;

const ListItem = styled.li`
  margin-bottom: 5px;
`;

// Services Component
const Services = () => {
  return (
    <Container>
      <Title>Kitchen Hamara Service Description</Title>

      <Section>
        <Paragraph>
          Kitchen Hamara is primarily a food delivery platform offering a wide range of services that extend beyond traditional food delivery. Below is an overview of the diverse services provided by Kitchen Hamara:
        </Paragraph>

        <List>
          <ListItem>
            <strong>1. Food Delivery</strong>
            <List>
              <ListItem>Restaurant Listings: Users can browse a vast selection of home cooks in their area.</ListItem>
              <ListItem>Online Ordering: Customers can place orders from their favorite home cooks and have food delivered to their doorstep.</ListItem>
              <ListItem>Real-Time Tracking: Track orders in real-time, from preparation to delivery.</ListItem>
              <ListItem>Scheduled Delivery: Option to schedule orders for a specific time.</ListItem>
              <ListItem>Contactless Delivery: Ensuring safer delivery options, especially post-COVID-19.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>2. Food Discovery and Reviews</strong>
            <List>
              <ListItem>Restaurant Reviews and Ratings: Users can read reviews and see ratings from other customers before deciding where to order from.</ListItem>
              <ListItem>Food Photography: View photos of dishes and restaurants for better decision-making.</ListItem>
              <ListItem>Curated Lists: Explore themed collections like 'Best Pizza Places,' 'Top Sushi Spots,' or 'Vegan-Friendly Restaurants.'</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>3. Grocery Delivery</strong>
            <List>
              <ListItem>Grocery Shopping: Order groceries, essentials, and household items from local stores.</ListItem>
              <ListItem>Quick Delivery: Kitchen Hamara offers express delivery within 10-30 minutes.</ListItem>
              <ListItem>Scheduled Orders: Option to set up recurring orders for regular grocery needs.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>4. Cloud Kitchen Support</strong>
            <List>
              <ListItem>Cloud Kitchens: Support for delivery-only kitchens that do not have physical dine-in spaces.</ListItem>
              <ListItem>Virtual Brands: Assistance in creating and managing virtual restaurant brands.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>5. Membership and Subscription Services</strong>
            <List>
              <ListItem>Loyalty Programs: Reward points, cashback, or discounts for frequent users.</ListItem>
              <ListItem>Subscription Plans: Exclusive benefits like free delivery, priority customer support, and access to special offers.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>6. Digital Payments and Wallet</strong>
            <List>
              <ListItem>Multiple Payment Options: Integration with various payment gateways (credit/debit cards, net banking, UPI, digital wallets).</ListItem>
              <ListItem>Split Bills: Option to split the bill among friends for group orders.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>7. Specialized Services</strong>
            <List>
              <ListItem>Meal Kits: Delivery of pre-portioned ingredients with recipes for customers to cook at home.</ListItem>
              <ListItem>Subscription Boxes: Weekly or monthly curated meal or grocery boxes.</ListItem>
              <ListItem>Corporate Orders: Catering services for office events or bulk orders.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>8. Event and Party Catering</strong>
            <List>
              <ListItem>Catering Services: Options for large orders for parties, weddings, or corporate events.</ListItem>
              <ListItem>Buffet Setup: Providing setup and serving staff for special occasions.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>9. Customer Support</strong>
            <List>
              <ListItem>24/7 Customer Service: In-app support via chat, calls, or email.</ListItem>
              <ListItem>Order Modification: Assistance in changing orders or delivery addresses.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>10. Promotions and Marketing for Restaurants</strong>
            <List>
              <ListItem>Advertisement Opportunities: Paid promotions for home cooks to increase visibility.</ListItem>
              <ListItem>Data Analytics: Insights for home cooks based on customer preferences, order patterns, and reviews.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>11. Health and Safety Features</strong>
            <List>
              <ListItem>Hygiene Ratings: Display of hygiene and safety ratings for home cooks.</ListItem>
              <ListItem>Contactless Payment: To minimize physical interaction.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>12. Sustainability Initiatives</strong>
            <List>
              <ListItem>Eco-Friendly Packaging: Encouraging the use of biodegradable or recyclable packaging.</ListItem>
              <ListItem>Carbon Footprint Tracking: Awareness campaigns for sustainable dining.</ListItem>
            </List>
          </ListItem>
        </List>
      </Section>
    </Container>
  );
};

export default Services;
